module.exports = __webpack_public_path__ + "static/media/avive_appuser_accepted_default.d36face2.svg";